import React, { useEffect } from "react";

function ImageLightbox({ src, alt, onClose }) {
  useEffect(() => {
    if (!src) return undefined;
    function handleKeyDown(e) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [src, onClose]);

  if (!src) return null;

  return (
    <div className="admin-lightbox" onClick={onClose}>
      <button type="button" className="admin-lightbox-close" onClick={onClose} aria-label="Close">
        ×
      </button>
      <img className="admin-lightbox-image" src={src} alt={alt} onClick={(e) => e.stopPropagation()} />
    </div>
  );
}

export default ImageLightbox;
